import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AutoUnsubscribe } from '../../decorators/auto-unsubscribe';
import { debounceTime } from 'rxjs/operators';

@AutoUnsubscribe
@Component({
  selector: 'ex-filter-text',
  templateUrl: './ex-filter-text.component.html',
  styleUrls: ['./ex-filter-text.component.scss']
})
export class ExFilterTextComponent {
  @Input() placeholder?: string;
  @Input() text?: string;
  @Input() variant: 'regular' | 'light' = 'regular';
  @Output() textEnter = new EventEmitter<string>();
  text$ = new BehaviorSubject<string | null>(null)
  isFocused = false;
  listen = false;

  @ContentChild('leftIconTemplate') leftIconTemplate?: TemplateRef<any>;

  constructor() {
    this.text$.pipe(debounceTime(1000)).subscribe((res) => {
      if (res !== null && this.listen)
        this.emitText();
    })
  }

  onInputFocus() {
    this.isFocused = true;
  }

  onInputBlur() {
    this.isFocused = false;
  }

  clearInput() {
    this.text = '';
    this.emitText();
  }

  emitText() {
    this.text = this.text?.trim();
    this.textEnter.emit(this.text);
    this.listen = false;
  }

  textChanged() {
    this.listen = true;
    this.text$.next(this.text ?? "");
  }
}
